let localStorage = window.localStorage

export default localStorage
